export default __webpack_public_path__ + "static/search-e3d703275d6cd06a0648575d85996b86.png";